import {Component, EventEmitter, Input, Output} from "@angular/core";
/**
 * Created by alex.y on 9/11/2017.
 */


@Component({
    selector: "management-search",
    templateUrl: "./managementSearch.component.html",
    moduleId: module.id.toString()
})
export class ManagementSearchComponent {

    @Output()
    public searchEventEmitter: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public createEventEmitter: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public showCreate: boolean = false;

    @Input()
    public createIcon: string = "";

    @Input()
    public helpText: string = "";

    @Input()
    public query: string = "";

    @Input()
    public showCleanFilter: boolean = false;

    @Input()
    public progress: boolean = false;

    @Input()
    public loading: boolean = false;

    @Output()
    public queryChange: EventEmitter<string> = new EventEmitter();

    public search(): void {
        this.queryChange.emit(this.query);
        this.searchEventEmitter.emit(true);
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/search/managementSearch.component.ts